import { z } from 'zod';
import { submitShortfallChoiceSchema } from './submit-shortfall-choice-input.js';
// The over-sale dialog: one choice for each short line, none may be left undecided, and a Back Order outcome needs the acknowledgement.
export const salesOrderShortfallChoiceFormSchema = z
    .object({
    choices: z
        .array(submitShortfallChoiceSchema.extend({ lineIndex: z.number().int().min(0) }))
        .min(1, 'There are no short lines to choose for.'),
    acknowledged: z.boolean(),
    // The dialog sets this from the planner: the whole order becomes a Back Order (a Keep line, or Back order choices that would leave nothing to ship).
    requiresAcknowledgement: z.boolean(),
})
    .refine((form) => !form.requiresAcknowledgement || form.acknowledged, {
    message: 'Confirm that this order will be submitted as a Back Order.',
    path: ['acknowledged'],
});
//# sourceMappingURL=shortfall-choice-form.js.map